export const SET_SID_SESSIONS = "SET_SID_SESSIONS";
export const SET_SID_SELECTED_SESSION = "SET_SID_SELECTED_SESSION";
export const SET_SID_MESSAGES = "SET_SID_MESSAGES";
export const PREPEND_SID_MESSAGES = "PREPEND_SID_MESSAGES";
export const ADD_SID_MESSAGE = "ADD_SID_MESSAGE";
export const SET_SID_THINKING = "SET_SID_THINKING";
export const SET_SID_LOADING_OLDER = "SET_SID_LOADING_OLDER";
export const EDIT_SID_MESSAGE = "EDIT_SID_MESSAGE";
export const DROP_LAST_SID_REPLY = "DROP_LAST_SID_REPLY";
export const SET_SID_MESSAGE_FEEDBACK = "SET_SID_MESSAGE_FEEDBACK";
export const SET_SID_INPUT_DRAFT = "SET_SID_INPUT_DRAFT";
export const CLEAR_SID_INPUT_DRAFT = "CLEAR_SID_INPUT_DRAFT";
